var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion__fullscreen accordion__fullscreen--wrapper",on:{"full-screen-accordion-click":_vm.handleItemClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }